import axios from '../localAxios';
import { leaveTeamURL } from './urls';

interface LeaveTeamParams {
  teamId: string;
}

export async function leaveTeam({ teamId }: LeaveTeamParams) {
  const url = leaveTeamURL(teamId);
  const result = await axios.delete<{ message: string }>(url.href);
  return result.data;
}
